export enum ProgramStatus {
  INVITE = 'Invite',
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  ENROLLED = 'Enrolled',
}
